import { useState } from "react";
import { useForm } from "@mantine/form";
import {
  Alert,
  Container,
  PasswordInput,
  Text,
  Paper,
  Group,
  Button,
  Anchor,
  Stack,
  Loader,
  Center,
} from "@mantine/core";
import { useStore } from "../store";
import { userConfirmation } from "../api";
import { useLocation } from "wouter";
import { IconInfoCircle } from "@tabler/icons-react";

export default function Confirmation({ params }) {
  const [, setLocation] = useLocation();
  const [isFetching, setIsFetching] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const authToken = useStore((state) => state.authToken);
  // const setAuthToken = useStore((state) => state.setAuthToken);

  const form = useForm({
    initialValues: {
      token: params.token,
      password: "",
    },
    validate: {
      password: (val) =>
        val.length < 8 ? "Password should include at least 8 characters" : null,
    },
  });

  if (authToken) {
    return (
      <Container size="sm" mt="xl">
        <Paper radius="md" p="xl" withBorder>
          <Text size="lg" fw={500}>
            You are already logged in
          </Text>
        </Paper>
      </Container>
    );
  }

  const errorIcon = <IconInfoCircle />;

  return (
    <Container size="sm" mt="xl">
      {errorMessage && (
        <Alert
          variant="light"
          color="red"
          title="Login Failed"
          mb="lg"
          icon={errorIcon}
        >
          {errorMessage}
        </Alert>
      )}

      <Paper radius="md" p="xl" withBorder>
        <Text size="lg" fw={500}>
          Welcome to PromptShuttle
        </Text>
        <Text size="md" mt="lg" mb="lg">
          Please set a password to confirm and activate your account!
        </Text>

        <form
          onSubmit={form.onSubmit((values) => {
            setIsFetching(true);
            setErrorMessage(null);

            userConfirmation(values)
              .then(() => {
                setIsFetching(false);
                // TBD: Indicate success, redirect
                // setAuthToken(data.access_token);
                setLocation("/auth/login");
              })
              .catch((err) => {
                setIsFetching(false);
                setErrorMessage("" + err);
              });
          })}
        >
          <Stack>
            <PasswordInput
              required
              disabled={isFetching}
              label="Password"
              placeholder="Choose a new password"
              value={form.values.password}
              onChange={(event) =>
                form.setFieldValue("password", event.currentTarget.value)
              }
              error={form.errors.password}
              radius="md"
            />
          </Stack>

          <Group justify="space-between" mt="xl">
            <Anchor
              component="button"
              type="button"
              c="dimmed"
              onClick={() => setLocation("/auth/register")}
              size="xs"
            >
              Don't have an account? Register
            </Anchor>
            <Button type="submit" radius="xl" disabled={isFetching}>
              Set Password
            </Button>
          </Group>

          <Center>{isFetching && <Loader />}</Center>
        </form>
      </Paper>
    </Container>
  );
}
